import { Assets, Container /*, Graphics, Text, TextStyle*/, Sprite } from "pixi.js";
import { globalScreen } from "../config/GlobalVariableConfig";



export class LoaderScene extends Container {
    public loaderBar: Container = new Container();

    private loaderBarBorder: Sprite | null = null;
    private loaderBarFill: Sprite | null = null;

    // public continueButton: Graphics = new Graphics();
    // public continueButtonContainer: Container = new Container();
    // private continueButtonWidth: number = 150;
    // private continueButtonHeight: number = 50;


    private background: Container = new Container();



    private screenWidth: number = 0;
    private screenHeight: number = 0;

    constructor() {
        super();
        // this.setupBackground();
        // this.setupContinueButton();
    }

    // private setupBackground(): void {

    //     this.addChild(this.background);
    // }

    private backgroundImage: Sprite | null = null;

    public async showInitLogo(screenWidth: number, screenHeight: number) {

        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;

        await Assets.load([
            { alias: 'studioName', src: 'assets/desktop/loading/nownow_gaming.webp' },
            { alias: 'logo', src: 'assets/desktop/loading/logo.webp' },
            { alias: 'loadingBg', src: 'assets/desktop/loading/loading_bg.webp' },
            { alias: 'loadingBar', src: 'assets/desktop/loading/loading_bar.webp' },
            { alias: 'loadingFill', src: 'assets/desktop/loading/loading_fill.webp' },
            { alias: 'companyName', src: 'assets/desktop/loading/hacksaw.webp' },
        ]);


        this.backgroundImage = Sprite.from('loadingBg');
        // const blurFilter = new BlurFilter();
        // blurFilter.strength = 10;
        // this.backgroundImage.filters = [blurFilter];

        this.addChild(this.backgroundImage);

        this.addChild(this.background);

        const studioName = Sprite.from('studioName');
        studioName.anchor = 0.5;
        studioName.position.set(globalScreen / 2, 574);

        this.background.addChild(studioName);



        const logo = Sprite.from('logo');
        logo.anchor = 0.5;
        logo.position.set(globalScreen / 2, 974);

        this.background.addChild(logo);



        this.loaderBarBorder = Sprite.from("loadingBar");
        this.loaderBarFill = Sprite.from("loadingFill");
        this.loaderBarFill.scale.x = 0;

        this.loaderBarFill.position.set(20, 10);

        // this.loaderBarFill.y = this.loaderBarBorder.height / 2 - this.loaderBarFill.height / 2 ;

        this.loaderBar.addChild(this.loaderBarBorder);
        this.loaderBar.addChild(this.loaderBarFill);

        this.loaderBar.pivot.set(this.loaderBar.width / 2, this.loaderBar.height / 2)
        this.loaderBar.position.set(globalScreen / 2, 1344);
        this.background.addChild(this.loaderBar);


        // this.continueButtonContainer.pivot.set(this.continueButtonContainer.width/2, this.continueButtonContainer.height/2)
        // this.continueButtonContainer.position.set(1500,1896);
        // this.background.addChild(this.continueButtonContainer);


        const companyName = Sprite.from('companyName');
        companyName.anchor = 0.5;
        companyName.position.set(globalScreen / 2, 1474);

        this.background.addChild(companyName);

        this.resize(this.screenWidth, this.screenHeight);

    }

    public downloadProgress = (progressRatio: number): void => {

        if (this.loaderBarFill) {
            this.loaderBarFill.scale.x = progressRatio;
        }
    }

    public resize(screenWidth: number, screenHeight: number): void {

        console.log(`loder resize screenWidth${screenWidth} screenHeight ${screenHeight}`);

        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;

        // const isLandscape = screenWidth > screenHeight;
        // const scale = (isLandscape ? .8 : 1.2) * Math.min(screenWidth / (isLandscape ? 1920 : 1080), screenHeight / (isLandscape ? 1080 : 1920));

        // this.background.scale.set(scale, scale);
        // const xPos = (3000 * scale - this.screenWidth) / 2;
        // const yPos = (3000 * scale - this.screenHeight) / 2;
        // this.background.x = -xPos;
        // this.background.y = -yPos;


        let scale: number;

        let bgScale;
        const BG_SCALE_FACTOR = Math.max(screenWidth / globalScreen, screenHeight / globalScreen);


        if (screenWidth > screenHeight) {
            scale = Math.min(screenWidth / 1920, screenHeight / 1080);
            bgScale = Math.max(scale, BG_SCALE_FACTOR);

            if(this.background){
                this.background.scale.set(scale, scale);
            }

            const xPos = (globalScreen * scale - screenWidth) / 2;
            const yPos = (globalScreen * scale - screenHeight) / 2;

            this.background.x = -xPos;
            this.background.y = -yPos;
            if(this.backgroundImage){
                this.backgroundImage.scale.set(bgScale, bgScale);
            }
            const bgXPos = (globalScreen * bgScale - screenWidth) / 2;
            const bgYPos = (globalScreen * bgScale - screenHeight) / 2;
            this.backgroundImage.position.set(-bgXPos, -bgYPos);

        }
        else {
            scale = 1.22 * Math.min(screenWidth / 1080, screenHeight / 1920);
            bgScale = Math.max(scale, BG_SCALE_FACTOR);

            if(this.background){
                this.background.scale.set(scale, scale);
            }

            const xPos = (globalScreen * scale - screenWidth) / 2;
            const yPos = (globalScreen * scale - screenHeight) / 2;

            this.background.x = -xPos;
            this.background.y = -yPos;

            if(this.backgroundImage){
                this.backgroundImage.scale.set(bgScale, bgScale);
            }
            const bgXPos = (globalScreen * bgScale - screenWidth) / 2;
            const bgYPos = (globalScreen * bgScale - screenHeight) / 2;
            this.backgroundImage.position.set(-bgXPos, -bgYPos);

        }
    }

}
